import { Button } from '@ds/core';
import { Modal } from '@ds/feedback';
import { NOVIDADES, VERSAO_DO_PRODUTO } from '@/data/novidades';

export interface NovidadesDaVersaoModalProps {
    onFechar: () => void;
}

/** "Novidades da versão", do rodapé do menu da conta — porte do modal de `App.jsx`. */
export function NovidadesDaVersaoModal({ onFechar }: NovidadesDaVersaoModalProps) {
    return (
        <Modal
            open width={480} onClose={onFechar}
            title={`Novidades da versão ${VERSAO_DO_PRODUTO}`}
            description="O que entrou nesta versão"
            footer={<Button onClick={onFechar}>Entendi</Button>}
        >
            <ul style={{ margin: 0, paddingLeft: 18, display: 'flex', flexDirection: 'column', gap: 10, fontSize: 13.5, lineHeight: '20px', color: 'var(--text-body)' }}>
                {NOVIDADES.map((n) => (
                    <li key={n.titulo}>
                        <strong style={{ fontWeight: 600, color: 'var(--text-primary)' }}>{n.titulo}.</strong> {n.descricao}
                    </li>
                ))}
            </ul>
        </Modal>
    );
}
